/**
 * Die Rolle, die in einem Firebase-Token steht.
 *
 * Custom Claims setzt ausschließlich der Server (Admin-SDK) — ein Client kann
 * sie nicht erfinden. Deshalb sind sie die Wahrheit darüber, was ein Konto
 * sein soll, und `firestore.rules` verlangt seit dem 10.09.2026, dass ein
 * selbst angelegtes Benutzerdokument ihnen entspricht.
 *
 * **Die Weißliste ist kein Zierrat.** Ohne sie landete eine unbekannte Marke
 * als Rolle im Dokument, und jede Abfrage `role === 'admin' | 'employee' |
 * 'educator'` liefe daran vorbei — ein Konto, das nirgends dazugehört.
 */

import type { UserRole } from '@cockpit/types/user';

const KNOWN_ROLES: readonly UserRole[] = ['admin', 'employee', 'educator'];

/** Ohne (oder mit unbekannter) Marke bleibt es beim gewöhnlichen Konto. */
export const DEFAULT_ROLE: UserRole = 'employee';

export function roleFromClaims(claims: Record<string, unknown>): UserRole {
  const claimed = claims.role;

  if (typeof claimed !== 'string') {
    return DEFAULT_ROLE;
  }

  return KNOWN_ROLES.includes(claimed as UserRole) ? (claimed as UserRole) : DEFAULT_ROLE;
}
